var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showTitle)?_c('p',{staticClass:"font-weight-bold"},[_vm._v("\n    "+_vm._s(_vm.$t('components.logBook.levels'))+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"level-chart",class:_vm.heightClass},[_c('bar-chart',{attrs:{"data":_vm.chartData,"options":{
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            ticks: {
              display: false
            }
          }]
        }
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }